<template>
  <el-dialog
    :title="title"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    width="900px"
    :before-close="cancel"
  >
    <el-form
      v-if="dialogVisible"
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      :inline="false"
      label-width="130px"
    >
      <el-form-item label="模板名称" prop="templateName">
        <el-input
          :disabled="type === 'details'"
          style="width: 350px"
          maxlength="25"
          size="small"
          clearable
          class="mr10 ipt"
          v-model.trim="ruleForm.templateName"
          placeholder="请输入模板名称"
        ></el-input>
      </el-form-item>

      <el-form-item label="模板类型" prop="templateType">
        <el-select
          :disabled="type === 'details'"
          class="mr10"
          size="small"
          style="width: 350px"
          v-model="ruleForm.templateType"
          placeholder="请选择模板类型"
          @change="typeChange"
        >
          <el-option label="小票日期" value="receiptDate"></el-option>
          <el-option label="小票号" value="receiptSn"></el-option>
          <el-option label="小票时间戳" value="receiptDateStr"></el-option>
          <el-option label="门店名称" value="shopName"></el-option>
          <el-option label="商品数量" value="number"></el-option>
          <el-option label="小票去重模板管理" value="receiptRepeat"></el-option>
        </el-select>
      </el-form-item>
      <div v-if="ruleForm.templateType !== 'receiptRepeat'">
        <div v-if="ruleForm.templateType === 'number'">
          <el-form-item label="数据所在行定位" prop="anchorType">
            锚点：
            <el-select
              :disabled="type === 'details'"
              clearable
              class="mr10"
              size="small"
              style="width: 150px"
              v-model="ruleForm.anchorType"
              placeholder="请选择锚点类型"
            >
              <el-option label="条码所在行" value="barcode"></el-option>
              <el-option label="商品名所在行" value="goods"></el-option>
            </el-select>
            相对位置：
            <el-select
              :disabled="type === 'details'"
              clearable
              style="width: 150px"
              class="mr10"
              size="small"
              v-model="ruleForm.relativePosition"
              @change="relativePositionChange"
              placeholder="请选择相对位置"
            >
              <el-option label="上一行" value="up"></el-option>
              <el-option label="同一行" value="same"></el-option>
              <el-option label="下一行" value="down"></el-option>
              <el-option label="小数点行" value="point"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所在行中提取" prop="relativeType">
            <div>
              锚点：
              <el-select
                :disabled="
                  type === 'details' || ruleForm.relativePosition === 'point'
                "
                clearable
                class="mr10"
                size="small"
                style="width: 150px"
                v-model="ruleForm.relativeType"
                placeholder="相对锚点位置类型"
                @change="relativeTypeChange"
              >
                <el-option label="无（数量在最前面）" value="null"></el-option>
                <el-option label="条码" value="barcode"></el-option>
                <el-option label="商品名" value="goods"></el-option>
                <el-option label="关键字" value="keyWord"></el-option>
                <el-option label="小数点" value="point"></el-option>
              </el-select>
              <el-input
                :disabled="type === 'details'"
                v-if="
                  ruleForm.relativeType === 'keyWord' ||
                    ruleForm.relativeType === 'point'
                "
                maxlength="25"
                size="small"
                style="width: 150px"
                clearable
                :placeholder="
                  ruleForm.relativeType === 'keyWord'
                    ? '请输入关键字'
                    : '请输入连续小数点数'
                "
                class="mr10 ipt"
                v-model.trim="ruleForm.keyWord"
              ></el-input>
            </div>
            <div v-if="ruleForm.relativeType === 'point'">
              第<el-input
                :disabled="type === 'details'"
                maxlength="25"
                size="small"
                style="width: 80px"
                clearable
                placeholder="
                          请输入连续小数点数
                      "
                class="ml10 mr10 ipt"
                @input="filterGt0('rowSeq')"
                v-model.trim="ruleForm.rowSeq"
              ></el-input
              >个小数点后，第<el-input
                :disabled="type === 'details'"
                maxlength="25"
                size="small"
                style="width: 80px"
                clearable
                class="ml10 mr10 ipt"
                @input="filterGt0('numIndex')"
                v-model.trim="ruleForm.numIndex"
              ></el-input
              >个起
            </div>
            <div v-else>
              相对位置：
              <el-select
                clearable
                :disabled="type === 'details'"
                class="mr10"
                style="width: 100px"
                size="small"
                v-model="ruleForm.rowSeq"
                placeholder="相对位置"
              >
                <el-option label="左侧" value="left"></el-option>
                <el-option label="右侧" value="right"></el-option>
              </el-select>
              定位 第<el-input
                maxlength="25"
                :disabled="type === 'details'"
                size="small"
                style="width: 80px"
                clearable
                class="mr10 ipt"
                @input="filterGt0('numIndex')"
                v-model.trim="ruleForm.numIndex"
              ></el-input
              >个起
            </div>
          </el-form-item>
        </div>
        <div v-else>
          <el-form-item label="关键字类型" prop="prefixType" v-if="ruleForm.templateType == 'receiptSn'">
            <el-radio-group :disabled="type === 'details'" v-model="ruleForm.prefixType">
              <el-radio :label="'notInclude'">关键字前缀</el-radio>
              <el-radio :label="'include'">关键字开头</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="ruleForm.prefixType == 'include' ? '以关键字开头' : '关键字前缀'" prop="pasLabels">
            <el-tag
              :key="tag"
              v-for="tag in ruleForm.pasLabels"
              :closable="type === 'add'"
              :disable-transitions="false"
              @close="handleClose(tag)"
              >{{ tag }}</el-tag
            >
            <el-input
              class="input-new-tag"
              v-if="inputVisible"
              v-model.trim="inputValue"
              ref="saveTagInput"
              size="small"
              maxlength="10"
              clearable
              placeholder="请输入标签，在10个汉字以内"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            ></el-input>
            <el-button
              v-else
              class="button-new-tag"
              size="small"
              @click="showInput"
              v-show="type === 'add'"
              >+ 关键字</el-button
            >
            <span class="form-red">不输入则不限制</span>
          </el-form-item>
          <el-form-item label="关键字后缀" prop="pasLabelsLast">
            <el-tag
              :key="tag"
              v-for="tag in ruleForm.pasLabelsLast"
              closable
              :disable-transitions="false"
              @close="handleCloseLast(tag)"
              >{{ tag }}</el-tag
            >
            <el-input
              class="input-new-tag"
              v-if="inputVisibleLast"
              v-model.trim="inputValueLast"
              ref="saveTagInputLast"
              size="small"
              maxlength="10"
              clearable
              placeholder="请输入关键字，在10个汉字以内"
              @keyup.enter.native="handleInputConfirmLast"
              @blur="handleInputConfirmLast"
            ></el-input>
            <el-button
              v-else
              class="button-new-tag"
              size="small"
              @click="showInputLast"
              v-show="type === 'add'"
              >+ 关键字</el-button
            >
            <span class="form-red">不输入则不限制</span>
          </el-form-item>
        </div>

        <el-form-item label="字符长度">
          <div class="flex">
            <el-form-item prop="minStrLength">
              <el-input
                :disabled="type === 'details'"
                type="number"
                maxlength="25"
                size="small"
                clearable
                class="mr10 ipt"
                style="width: 156px"
                v-model.trim="ruleForm.minStrLength"
              ></el-input>
            </el-form-item>
            ~
            <el-form-item prop="maxStrLength">
              <el-input
                :disabled="type === 'details'"
                type="number"
                maxlength="25"
                size="small"
                clearable
                class="ml10 ipt"
                style="width: 156px"
                v-model.trim="ruleForm.maxStrLength"
              ></el-input>
            </el-form-item>
          </div>
        </el-form-item>
        <el-form-item label="字符串格式" prop="strDemo">
          <el-input
            v-if="ruleForm.templateType !== 'receiptDate'"
            :disabled="type === 'details'"
            style="width: 350px"
            maxlength="25"
            size="small"
            clearable
            class="mr10 ipt"
            v-model="ruleForm.strDemo"
            :placeholder="placeholder"
          ></el-input>
          <el-select
            v-else
            clearable
            class="mr10"
            :disabled="type === 'details'"
            size="small"
            style="width:350px"
            v-model="ruleForm.strDemo"
            placeholder="请选择时间格式"
          >
            <el-option label="yyyyMd (例：2021/5/1)" value="yyyyMd"></el-option>
            <el-option
              label="yyyyMdd (例：2021/5/01)"
              value="yyyyMdd"
            ></el-option>
            <el-option
              label="yyyyMMd (例：2021/05/1)"
              value="yyyyMMd"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="正则表达式">
          <el-input v-model.trim="ruleForm.regularExtractRule" style="width: 350px" size="small" placeholder="请输入正则表达式"></el-input>
        </el-form-item>
        <!-- <el-form-item label="时间格式" prop="templateFormatDate" v-if="ruleForm.templateType==='receiptDate'||ruleForm.templateType==='receiptDateStr'">
              <el-select
                clearable
                class="mr10"
                size="small"
                style="width:350px"
                v-model="ruleForm.templateFormatDate"
                placeholder="时间格式"
              >
                <el-option label="yyy" value="goods"></el-option>
                <el-option label="mmm" value="keyWord"></el-option>
              </el-select>
            </el-form-item> -->
        <el-form-item label="是否允许包含符号" prop="charEnable">
          <el-switch
            :disabled="type === 'details'"
            size="mini"
            v-model="ruleForm.charEnable"
            active-text="允许"
            inactive-text="禁止"
            active-color="#2fc348"
            inactive-color="#ff0000"
            active-value="yes"
            inactive-value="no"
          ></el-switch>
        </el-form-item>
      </div>
      <div v-else>
        <el-form-item label="转人工关键字" prop="keyRepeatList">
          <el-tag
            :key="tag"
            v-for="tag in ruleForm.keyRepeatList"
            closable
            :disable-transitions="false"
            @close="handleCloseKey(tag)"
            >{{ tag }}</el-tag
          >
          <el-input
            class="input-new-tag"
            v-if="inputVisibleKey"
            v-model.trim="inputValueKey"
            ref="saveTagInputKey"
            size="small"
            maxlength="10"
            clearable
            placeholder="请输入标签，在10个汉字以内"
            @keyup.enter.native="handleInputConfirmKey"
            @blur="handleInputConfirmKey"
          ></el-input>
          <el-button
            v-else
            class="button-new-tag"
            size="small"
            @click="showInputKey"
            v-show="type === 'add'"
            >+ 关键字</el-button
          >
        </el-form-item>
        <el-form-item label="去重规则" prop="repeatRule">
          <el-select
            :disabled="type === 'details'"
            clearable
            class="mr10"
            size="small"
            style="width: 350px"
            v-model="ruleForm.repeatRule"
            placeholder="去重规则"
          >
            <el-option label="小票优先" value="receiptSn"></el-option>
            <el-option label="小票时间优先" value="receiptDateStr"></el-option>
            <el-option label="并行" value="both"></el-option>
          </el-select>
        </el-form-item>
      </div>

      <el-form-item label="小票示例" prop="templateImg">
        <el-upload
          class="upload flex"
          ref="eluploadMainPic"
          :limit="1"
          drag
          :data="{ fileDir: 'mall' }"
          :headers="{ 'X-Access-Token': $token }"
          :action="$uploadUrl"
          :onSuccess="uploadMainPicSucc"
          :beforeUpload="beforeUpload"
          :onProgress="uploading"
          :show-file-list="uploadShow"
          v-if="!ruleForm.templateImg"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将图片拖到此处，或
            <em>点击上传</em>
          </div>
        </el-upload>
        <div class="priview" v-if="ruleForm.templateImg">
          <img :src="ruleForm.templateImg" alt="主图" />
          <div
            class="opreat-wrapper flex item-center flex-center"
            v-if="type === 'add'"
          >
            <el-button type="text" @click="handleRemove">删除</el-button>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="是否启用" prop="enableState">
        <el-switch
          :disabled="type === 'details'"
          size="mini"
          v-model="ruleForm.enableState"
          active-text="启用"
          inactive-text="禁用"
          active-color="#2fc348"
          inactive-color="#ff0000"
          active-value="yes"
          inactive-value="no"
        ></el-switch>
        <span class="form-red">关闭状态下直接启用系统默认规则</span>
      </el-form-item>
      <el-form-item label="模板描述" prop="description">
        <el-input
          :disabled="type === 'details'"
          style="width: 360px"
          type="textarea"
          v-model="ruleForm.description"
          placeholder="多行文本，请输入模板描述"
        ></el-input>
      </el-form-item>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer flex flex-center mt20"
      v-if="type === 'add'"
    >
      <el-button @click="submitForm('ruleForm')" size="small" type="primary">
        确 认</el-button
      >
      <el-button size="small" @click="cancel">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { unique } from "@/utils/utils";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: ""
    }
  },
  components: {},
  data() {
    const strLengt = (rule, val, callback) => {
      if (
        this.ruleForm.minStrLength !== "" &&
        this.ruleForm.maxStrLength !== ""
      ) {
        if (
          new Number(this.ruleForm.minStrLength) >
          new Number(this.ruleForm.maxStrLength)
        ) {
          let min = JSON.parse(JSON.stringify(this.ruleForm.minStrLength));
          let max = JSON.parse(JSON.stringify(this.ruleForm.maxStrLength));
          this.ruleForm.minStrLength = max;
          this.ruleForm.maxStrLength = min;
          callback();
        }
      }
      callback();
    };
    const validatoranchorType = (rule, val, callback) => {
      if (this.ruleForm.relativePosition == "") {
        return callback(new Error("请选择相对位置！"));
      }
      callback();
    };
    const validatorRelativeType = (rule, val, callback) => {
      if (
        this.ruleForm.relativeType === "keyWord" &&
        this.ruleForm.keyWord == ""
      ) {
        return callback(new Error("请输入关键字！"));
      } else {
        if (this.ruleForm.rowSeq == "") {
          return callback(new Error("请选择行相对位置！"));
        }
        if (this.ruleForm.numIndex == "") {
          return callback(new Error("请输入定位数字位置!"));
        }
      }
      callback();
    };
    return {
      title: "",
      inputValueKey: "",
      inputVisibleKey: false,
      inputValueLast: "",
      inputVisibleLast: false,
      inputValue: "",
      inputVisible: false,
      uploadShow: true,
      isSaving: false,
      placeholder: "例如：2020-12-01 19:00:00",
      ruleForm: {
        repeatRule: "",
        charEnable: "no",
        enableState: "no",
        keyPrefix: "",
        keySuffix: "",
        strDemo: "",
        maxStrLength: "",
        minStrLength: "",
        templateType: "receiptDate",
        pasLabels: [],
        pasLabelsLast: [],
        keyRepeatList: [],
        keyRepeat: "",
        templateName: "",
        anchorType: "",
        relativePosition: "",
        relativeType: "",
        keyWord: "",
        rowSeq: "",
        numIndex: "",
        templateImg: "",
        description: "",
        prefixType: "notInclude",
        regularExtractRule: ""
      },
      rules: {
        templateName: {
          required: true,
          message: "请输入模板名称",
          trigger: "change"
        },
        templateType: {
          required: true,
          message: "请选择模板类型",
          trigger: "change"
        },
        repeatRule: {
          required: true,
          message: "请选择去重规则",
          trigger: "change"
        },
        maxStrLength: {
          validator: strLengt,
          trigger: "blur"
        },
        minStrLength: {
          validator: strLengt,
          trigger: "blur"
        },
        anchorType: [
          {
            required: true,
            message: "请选择锚点类型",
            trigger: "change"
          },
          {
            required: true,
            validator: validatoranchorType
          }
        ],
        relativeType: [
          {
            required: true,
            message: "请选择相对锚点位置类型",
            trigger: "change"
          },
          {
            required: true,
            validator: validatorRelativeType
          }
        ],
        templateImg: {
          required: true,
          message: "请输入小票示例",
          trigger: "change"
        },
        enableState: {
          required: true
        }
      }
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    if (this.type === "add") {
      this.title = "新增模板";
      //   this.dialogVisible = true;
    } else if (this.type === "details") {
      this.title = "模板详情";
      //   this.type = "edit";
      //   this.dialogVisible = true;
      this.queryDetails();
    }
  },
  methods: {
    relativePositionChange(val) {
      if (val === "point") {
        this.ruleForm.relativeType = val;
      }
    },
    async queryDetails() {
      this.$store
        .dispatch("sysReceiptOcrTemplateDetails", { id: this.id })
        .then(res => {
          if (res.code === "0") {
            for (let key in this.ruleForm) {
              this.ruleForm[key] = res.result[key];
            }
            if (this.ruleForm.templateType === "receiptRepeat") {
              if (this.ruleForm.keyRepeat !== "0" && this.ruleForm.keyRepeat) {
                this.ruleForm.keyRepeatList = this.ruleForm.keyRepeat.split(
                  ","
                );
              }
              this.ruleForm.pasLabels = [];
              this.ruleForm.pasLabelsLast = [];
            } else {
              if (this.ruleForm.keyPrefix !== "0" && this.ruleForm.keyPrefix) {
                this.ruleForm.pasLabels = this.ruleForm.keyPrefix.split(",");
              } else {
                this.ruleForm.pasLabels = [];
              }

              if (this.ruleForm.keySuffix !== "0" && this.ruleForm.keySuffix) {
                this.ruleForm.pasLabelsLast = this.ruleForm.keySuffix.split(
                  ","
                );
              } else {
                this.ruleForm.pasLabelsLast = [];
              }
              this.ruleForm.keyRepeatList = [];
            }
            this.ruleForm.id = res.result.id;
          }
        });
    },
    typeChange(val) {
      if (val === "receiptDate") {
        this.placeholder = "例如：2020-12-01 19:00:00";
      } else if (val === "receiptSn") {
        this.placeholder = "输入一个示例小票号，例如：FBD202010512312345";
      } else if (val === "receiptDateStr" || val === "shopName") {
        this.placeholder = "输入一个示例时间戳，例如：20201212121212";
      }
      if (val == "receiptDate") {
        this.ruleForm.strDemo = "";
      }
    },
    showInputKey() {
      this.inputVisibleKey = true;
      this.$nextTick(() => {
        this.$refs.saveTagInputKey.$refs.input.focus();
      });
    },
    handleInputConfirmKey() {
      let inputValue = this.inputValueKey;
      if (inputValue) {
        this.ruleForm.keyRepeatList.push(inputValue);
        this.ruleForm.keyRepeatList = unique(this.ruleForm.keyRepeatList);
      }
      this.inputVisibleKey = false;
      this.inputValueKey = "";
    },
    handleCloseKey(tag) {
      this.ruleForm.keyRepeatList.splice(
        this.ruleForm.keyRepeatList.indexOf(tag),
        1
      );
    },
    showInputLast() {
      this.inputVisibleLast = true;
      this.$nextTick(() => {
        this.$refs.saveTagInputLast.$refs.input.focus();
      });
    },
    handleInputConfirmLast() {
      let inputValue = this.inputValueLast;
      if (inputValue) {
        this.ruleForm.pasLabelsLast.push(inputValue);
        this.ruleForm.pasLabelsLast = unique(this.ruleForm.pasLabelsLast);
      }
      this.inputVisibleLast = false;
      this.inputValueLast = "";
    },
    handleCloseLast(tag) {
      this.ruleForm.pasLabelsLast.splice(
        this.ruleForm.pasLabelsLast.indexOf(tag),
        1
      );
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.ruleForm.pasLabels.push(inputValue);
        this.ruleForm.pasLabels = unique(this.ruleForm.pasLabels);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    handleClose(tag) {
      this.ruleForm.pasLabels.splice(this.ruleForm.pasLabels.indexOf(tag), 1);
    },
    relativeTypeChange(val) {
      if (val != "keyWord") {
        this.ruleForm.keyWord = "";
      }
      if (val != "point") {
        this.ruleForm.rowSeq = "";
      }
    },
    filterGt0(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)|[^\d]+/g, "");
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "");
    },
    resetRuleForm() {
      this.$refs.ruleForm.resetFields();
      this.ruleForm.id = "";
      this.ruleForm.keyWord = "";
      this.ruleForm.numIndex = "";
      this.ruleForm.rowSeq = "";
      this.ruleForm.relativePosition = "";
      this.ruleForm.keyRepeatList = [];
      this.ruleForm.pasLabels = [];
      this.ruleForm.pasLabelsLast = [];
      this.ruleForm.regularExtractRule = "";
      this.ruleForm.prefixType = "notInclude";
      this.$forceUpdate();
    },
    cancel() {
      //   this.resetRuleForm();

      //   this.dialogVisible = false;
      this.$emit("cancel");
    },
    async submitForm(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        let params = JSON.parse(JSON.stringify(this.ruleForm));
        if (this.ruleForm.templateType === "receiptRepeat") {
          if (params.keyRepeatList.length) {
            params.keyRepeat = params.keyRepeatList.join(",");
          }
        } else {
          if (params.pasLabels.length) {
            params.keyPrefix = params.pasLabels.join(",");
          }
          if (params.pasLabelsLast.length) {
            params.keySuffix = params.pasLabelsLast.join(",");
          }
        }

        let name =
          this.type === "add"
            ? "sysReceiptOcrTemplateAdd"
            : "sysReceiptOcrTemplateEdit";

        const { code } = await this.$store.dispatch(name, params);
        if (code === "0") {
          this.$message({
            type: "success",
            message: "操作成功"
          });
          //   this.dialogVisible = false;
          //   this.queryList();
          this.resetRuleForm();
          this.$emit("refresh");
        }
      }
    },
    beforeUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
          "jpg" ||
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "gif";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      //   const limitSize = file.size / 1024 <= 1020;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning"
        });
      }
      //   if (!limitSize) {
      //     this.$message({
      //       message: "上传模板大小不能超过 1M!",
      //       type: "warning"
      //     });
      //   }
      return extension || extension2 || extension3 || extension4;
    },
    handleRemove() {
      this.ruleForm.templateImg = "";
    },
    // 上传错误
    uploadError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
      this.isSaving = false;
    },
    // 正在上传
    uploading() {
      this.isSaving = true;
      this.uploadShow = true;
    },
    uploadListDetailError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
    },
    uploadMainPicSucc(jsonData) {
      if (jsonData.code === 0) {
        this.ruleForm.templateImg = jsonData.result;
        this.uploadShow = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.priview {
  position: relative;
  width: 375px;
  height: 178px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
</style>
